module.exports = __webpack_public_path__ + "static/media/69_iron_metal_seamless.a500deda.jpg";